export type ImmoTrackingContext = 'overview' | 'detail_tenant' | 'default' | 'meinplus';

/**
 * Map of all possible tracking page titles for different contexts
 * Using direct key-value pairs for simplicity and maintainability
 */
export const immoTrackingPageTitles: Record<string, string> = {
  overview: 'overview.ainavio',
  detail_tenant: 'detail.tenant.ainavio',
  default: 'detail.ainavio',
  meinplus: 'ainavio',
};

export function determineImmoPageTitle(context: string = 'default'): string {
  return immoTrackingPageTitles[context] || immoTrackingPageTitles.default;
}

/**
 * Determine the appropriate tracking context based on the real estate object
 * Pure declarative approach with no conditionals
 *
 * @param realEstateObject - The real estate object with user specifics
 * @returns The appropriate tracking context
 */
export function determineImmoTrackingContext(realEstateObject?: any): ImmoTrackingContext {
  if (!realEstateObject || Object.keys(realEstateObject).length === 0) {
    return 'overview';
  }

  const userRole = realEstateObject?.userSpecifics?.roles?.[0] || '';

  const roleContextMap: Record<string, ImmoTrackingContext> = {
    TENANT: 'detail_tenant',
  };

  return userRole in roleContextMap ? roleContextMap[userRole] : 'default';
}
